export type EnhancingTag = "lit" | "ice";

export function parsePrizepicksEnhancingTag(
	prizepicks_enhancing_tag: string | null | undefined
): EnhancingTag | undefined {
	if (prizepicks_enhancing_tag === "demon") {
		return "lit";
	}

	if (prizepicks_enhancing_tag === "goblin") {
		return "ice";
	}

	return undefined;
}

export function parsePrizepicksEnhancingTagOrFail(
	prizepicks_enhancing_tag: string | null | undefined
): EnhancingTag {
	const enhancing_tag = parsePrizepicksEnhancingTag(prizepicks_enhancing_tag);

	if (!enhancing_tag) {
		throw new Error(`Unknown prizepicks enhancing tag: ${String(prizepicks_enhancing_tag)}`);
	}

	return enhancing_tag;
}
